import { Link } from "react-router-dom";
import { AppBar, Box, Container, Toolbar, Button, Divider } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import { theme } from "../../../theme";
import { useTranslation } from 'react-i18next';

import ProfileDropdown from "./profil";
import FutureAppointmentDropdown from "./futureAppointment";
import NotificationsDropdown from "./notifications";
import LanguageSelector from "../../LanguageSelector/LanguageSelector";
import ClientMessagesButton from '../messaging/ClientMessagesButton';

const ClientHeader = () => {
  const { i18n } = useTranslation();

  // Determine logo based on language
  const logoSrc = i18n.language === 'ar' ? '/assets/logo_white_ar.png' : '/assets/logo_white.png';

  const handleBackToHome = () => {
    // Navigate to landing page with bypass parameter to prevent auth redirect
    window.location.replace('/?bypass=true');
  };

  return (
    <AppBar position="static" sx={{ 
      backgroundColor: theme.colors.primary[500],
      py: { xs: 0.5, sm: 1 },
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
        <Toolbar 
          disableGutters
          sx={{
            minHeight: { xs: '52px', sm: '64px' },
            gap: { xs: 0.5, sm: 1 },
            overflow: 'hidden',
          }}
        >
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            onClick={handleBackToHome}
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              mr: { xs: 0.25, sm: 1 },
              height: { xs: '34px', sm: '50px' },
              maxWidth: { xs: '108px', sm: '150px' },
              flexShrink: 1,
              minWidth: 0,
            }}
          >
            <Box
              component="img"
              src={logoSrc}
              alt="Saloone"
              sx={{
                height: '100%',
                width: 'auto',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
          
          {/* Divider */}
          <Divider 
            orientation="vertical" 
            flexItem 
            sx={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.3)', 
              height: '30px',
              my: 'auto',
              mx: { xs: 0.5, sm: 1 },
              display: { xs: 'none', sm: 'block' },
            }} 
          />
          
          {/* Home Button */}
          <Button
            component={Link}
            to="/client"
            sx={{
              color: 'white',
              minWidth: { xs: '34px', sm: '40px' },
              width: { xs: '34px', sm: '40px' },
              height: { xs: '34px', sm: '40px' },
              p: 0,
              borderRadius: '50%',
              ml: { xs: 0, sm: 1 },
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <HomeIcon sx={{ 
              color: 'white',
              fontSize: { xs: '1.45rem', sm: '1.75rem' },
            }} />
          </Button>
          
          {/* Spacer to push dropdowns to the right */}
          <Box sx={{ flexGrow: 1 }} />
          
          {/* Dropdowns on the right */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: { xs: 0.5, sm: 2 },
            flexShrink: 0,
            '& > *': {
              minWidth: { xs: '34px', sm: '40px' },
              width: { xs: '34px', sm: '40px' },
              height: { xs: '34px', sm: '40px' },
              p: 0,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            },
            '& .MuiIconButton-root': {
              width: { xs: '34px', sm: '40px' },
              height: { xs: '34px', sm: '40px' },
              padding: 0,
            }
          }}>
            {/* Language Selector */}
            <LanguageSelector 
              size="small" 
              variant="standard"
              sx={{ 
                minWidth: { xs: '54px !important', sm: '60px !important' },
                width: { xs: '54px !important', sm: '60px !important' },
                '& .MuiSelect-select': {
                  color: 'white',
                  fontWeight: 600,
                  paddingRight: { xs: '18px !important', sm: '24px !important' },
                  paddingLeft: { xs: '4px !important', sm: '8px !important' },
                  fontSize: { xs: '0.78rem', sm: '0.875rem' },
                },
                '& .MuiSelect-icon': {
                  color: 'white',
                },
                '&:before, &:after': {
                  display: 'none',
                },
              }}
            />
            <FutureAppointmentDropdown />
            <NotificationsDropdown />
            <ClientMessagesButton />
            <ProfileDropdown />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ClientHeader;
